(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-description-more"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-description-more')) {
    customElements.define('product-description-more', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const content = this.querySelector('[data-description-content]');
        const button = this.querySelector('button');
        content.id = 'description-' + crypto.randomUUID();
        button.setAttribute('aria-controls', content.id);
        let expanded = false;
        const update = () => {
          const limit = parseFloat(getComputedStyle(this).getPropertyValue('--description-preview-height'));
          const needsToggle = content.scrollHeight > limit + 20;
          this.classList.toggle('is-collapsed', needsToggle && !expanded);
          button.hidden = !needsToggle;
          button.setAttribute('aria-expanded', String(expanded));
          button.querySelector('[data-toggle-label]').textContent = expanded ? 'Read less' : 'Read more';
        };
        button.addEventListener('click', () => {
          expanded = !expanded;
          update();
          if (!expanded) this.scrollIntoView({block: 'nearest'});
        });
        this.descriptionObserver = new ResizeObserver(update);
        this.descriptionObserver.observe(this);
        update();
      }
      disconnectedCallback() {
        this.descriptionObserver?.disconnect();
        delete this.dataset.ready;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
